import { PayloadAction } from "@reduxjs/toolkit";
import { Status } from "../../../../common/models/Status";
import { UserState } from "../models/UserState";

const setTokenStatus = (state: UserState, action: PayloadAction<Status>) => {
    state.tokenStatus = action.payload.status;
}

export default setTokenStatus;